import * as React from "react";
import { useRouterState } from "@tanstack/react-router";

// Site-wide reading-progress-bar-as-instruction-pointer. Per the
// design-reference README, blog posts had their own `#progress-rail` /
// `#progress-bar` / `#ip-label` (see PostReadingChrome.tsx), but the task is
// for the IP pointer to track scroll on every route, not just posts — so
// this mounts once in __root.tsx and tracks document scroll generically.
export function ScrollProgress() {
  const [pct, setPct] = React.useState(0);
  // Reset to 0 on route change instead of carrying over the previous page's
  // scroll fraction for a frame.
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  React.useEffect(() => {
    function onScroll() {
      const html = document.documentElement;
      const scrollable = html.scrollHeight - html.clientHeight;
      const p = scrollable > 0 ? (html.scrollTop / scrollable) * 100 : 0;
      setPct(Math.max(0, Math.min(100, p)));
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname]);

  const ipHex = String(Math.floor(pct * 2.55)).padStart(4, "0");

  return (
    <>
      <div id="progress-rail">
        <div id="progress-bar" style={{ transform: `scaleX(${pct / 100})` }} />
      </div>
      <div id="ip-label">ip &rarr; 0x{ipHex}</div>
    </>
  );
}
